export default __webpack_public_path__ + "media/zurb/img/icons/favicon/apple-touch-icon-114x114-391cb3735b87502df4d6c0a80ccd9b78.png";